export const Sections = {
  HOME: 0,
  PRE_K: 1,
  KIDERGARDEN: 2,
  GRADE_1: 3,
  GRADE_2: 4,
  GRADE_3: 5,
  GRADE_4: 6
};
